<template>
	<view class="setup">
		<div class="setup-tx">
			<view class="setup-tx-image">
				<image src="/static/logo.png" mode="widthFix"></image>
			</view>
			<button open-type="chooseAvatar" class="setup-tx-btn">更换头像</button>
		</div>
		<view class="setup-list">
			<view class="setup-list-item">
				<view class="label">昵称</view>
				<view class="val">
					<input type="text" placeholder="请输入" />
				</view>
			</view>
			<view class="setup-list-item">
				<view class="label">真实姓名</view>
				<view class="val">
					<input type="text" placeholder="请输入" />
				</view>
			</view>
			<view class="setup-list-item">
				<view class="label">绑定手机</view>
				<view class="val">
					<button open-type="getPhoneNumber">授权</button>
				</view>
			</view>
		</view>
		<view class="setup-sub">退出登录</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.setup {
		width: 100%;
		padding: 0 40rpx;
		box-sizing: border-box;
		.setup-tx {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin-top: 64rpx;
			.setup-tx-image {
				width: 160rpx;
				height: 160rpx;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				overflow: hidden;
				background: rgba(91,190,56,0.3);
				border: 2rpx solid rgba(91,190,56,0.35);
				image {
					width: 100%;
				}
			}
			.setup-tx-btn {
				width: 176rpx;
				height: 48rpx;
				line-height: 48rpx;
				text-align: center;
				border-radius: 32rpx;
				font-weight: 400;
				font-size: 26rpx;
				color: #5BBE38;
				border: 1rpx solid #5BBE38;
				background-color: #ffffff;
				margin-top: 24rpx;
			}
		}
		.setup-list {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 40rpx;
			.setup-list-item {
				width: 100%;
				height: 112rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1rpx solid #E5E5E5;
				.label {
					font-weight: 400;
					font-size: 30rpx;
					color: #222222;
					flex-shrink: 0;
					width: 150rpx;
					margin-right: 30rpx;
				}
				.val {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: flex-end;
					input {
						width: 100%;
						height: 100%;
						font-weight: 400;
						font-size: 28rpx;
						color: #222222;
						text-align: right;
					}
					button {
						width: 148rpx;
						height: 60rpx;
						line-height: 60rpx;
						text-align: center;
						background: #5BBE38;
						border-radius: 30rpx;
						font-weight: 500;
						font-size: 28rpx;
						color: #FFFFFF;
						margin: 0 !important;
					}
				}
			}
		}
		.setup-sub {
			width: 100%;
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			box-shadow: 0rpx 8rpx 12rpx 0rpx rgba(91,190,56,0.16);
			border-radius: 44rpx;
			font-weight: 500;
			font-size: 32rpx;
			color: #5BBE38;
			margin-top: 80rpx;
			border: 1rpx solid #15CF52;
		}
	}
</style>
